export default class ListingFilters {
    static init() {
        this.filter = document.querySelector(".listing-filter");
        if (!this.filter) {
            return;
        }

        this.initFilter();
    }

    static initFilter() {
        let postTypePath = this.filter.dataset.postTypePath;

        this.filter.addEventListener("change", () => {
            let url = this.filter.value;
            console.log(url);
            window.location.replace( url );
        });
    }
}